export const FactDetailTabsEnum = {
  OVERVIEW: 0,
  SUGGESTIONS: 1,
};

export default FactDetailTabsEnum;

